const createOptions = (unit, count) =>
  Array.from({ length: count }, (_, i) => ({
    id: i + 1,
    name: `${i + 1} ${unit}${i + 1 === 1 ? "" : "s"}`,
  }));

export const addEditEventsConst = {
  repeatOptionsFrequency: [
    { id: 1, name: "Daily", showType: "day" },
    { id: 2, name: "Weekly", showType: "week" },
    { id: 3, name: "Monthly", showType: "month" },
    { id: 4, name: "Yearly", showType: "year" },
  ],
  repeatEveryOptionsMap: {
    1: createOptions("Day", 99),
    2: createOptions("Week", 99),
    3: createOptions("month", 99),
    4: createOptions("year", 99),
  },
  dayMap: {
    1: "Mon",
    2: "Tue",
    3: "Wed",
    4: "Thu",
    5: "Fri",
    6: "Sat",
    7: "Sun",
  },
  days: [
    { day: "S", value: 7 },
    { day: "M", value: 1 },
    { day: "T", value: 2 },
    { day: "W", value: 3 },
    { day: "T", value: 4 },
    { day: "F", value: 5 },
    { day: "S", value: 6 },
  ],
  weekdays: [
    { id: 7, name: "Sunday" },
    { id: 1, name: "Monday" },
    { id: 2, name: "Tuesday" },
    { id: 3, name: "Wednesday" },
    { id: 4, name: "Thursday" },
    { id: 5, name: "Friday" },
    { id: 6, name: "Saturday" },
    { id: 8, name: "Weekday" },
    { id: 9, name: "Weekend Day" },
  ],
  onTheWeekdays: [
    { id: 7, name: "Sunday" },
    { id: 1, name: "Monday" },
    { id: 2, name: "Tuesday" },
    { id: 3, name: "Wednesday" },
    { id: 4, name: "Thursday" },
    { id: 5, name: "Friday" },
    { id: 6, name: "Saturday" },
    { id: 8, name: "Weekday" },
    { id: 9, name: "Weekend Day" },
    // { id: 8, name: "day" },
    // { id: 9, name: "weekday" },
    // { id: 10, name: "weekend day" },
  ],
  forYearlyMonthsArray: [
    { id: 1, name: "Jan" },
    { id: 2, name: "Feb" },
    { id: 3, name: "Mar" },
    { id: 4, name: "Apr" },
    { id: 5, name: "May" },
    { id: 6, name: "Jun" },
    { id: 7, name: "Jul" },
    { id: 8, name: "Aug" },
    { id: 9, name: "Sep" },
    { id: 10, name: "Oct" },
    { id: 11, name: "Nov" },
    { id: 12, name: "Dec" },
  ],
  firstToLast: [
    { id: 1, name: "First" },
    { id: 2, name: "Second" },
    { id: 3, name: "Third" },
    { id: 4, name: "Fourth" },
    { id: 5, name: "Fifth" },
    { id: 6, name: "Last" },
  ],
  repeatedOptionsValues: {
    never: 1,
    everyWeek: 2,
    everyDay: 3,
    every2Week: 4,
    month: 5,
    year: 6,
    custom: 7,
  },
  repeatedOptions: (t) => [
    { id: 1, name: `${t("scheduler.never")}` },
    // {
    //   id: 2,
    //   name: `${t("scheduler.repeatForAll")} ${moment(eventDate).format(
    //     "dddd"
    //   )}`,
    // },
    // { id: 3, name: `${t("scheduler.repeatForAllFuture")}` },

    // This code is require for the next sprint of Schedular (For new repeat options)
    { id: 3, name: `${t("everyDay")}` },
    { id: 2, name: `${t("everyWeek")}` },
    // { id: 4, name: `${t("every2Week")}` },
    { id: 5, name: `${t("everyMonth")}` },
    { id: 6, name: `${t("everyYear")}` },
    { id: 7, name: `${t("custom")}` },
  ],

  dropdown: (t, onlyOfficeSelection, eventOrShift) => {
    const options = [
      {
        name: onlyOfficeSelection
          ? t("accountOwner.allowRequestForStaffMembers")
          : t("accountOwner.allowInvitees"),
        // msg: t("accountOwner.allowInviteesMsg"),
        id: "allowInvitees",
      },
      {
        name: t("accountOwner.saveDraft"),
        // msg: t("accountOwner.saveDraftMsg"),
        id: "saveDraft",
      },
    ];
    if (!onlyOfficeSelection) {
      options.unshift({
        name: t("accountOwner.inviteesOnly", eventOrShift),
        // msg: t("accountOwner.inviteesOnlyMsg"),
        id: "inviteesOnly",
      });
    }
    return options;
  },
  otherOptions: (t, onlyOfficeSelection) => {
    const options = [
      {
        title: t("accountOwner.nonInviteeSecondOption"),
        id: 2,
      },
      {
        title: t(
          onlyOfficeSelection
            ? "accountOwner.nonInviteeFourthOption"
            : "accountOwner.nonInviteeThirdOption"
        ),
        id: 3,
      },
    ];
    if (!onlyOfficeSelection) {
      options.unshift({
        title: t("accountOwner.nonInviteeFirstOption"),
        id: 1,
      });
    }
    return options;
  },
};
